"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.webInteractionTypes = exports.visibilityTypes = exports.refinementTypes = exports.qualledTypes = exports.loginTypes = exports.loginStatusTypes = exports.formTypes = exports.currencyCodes = exports.booleanTypes = void 0;
var booleanTypes = exports.booleanTypes = {
  YES: 'yes',
  NO: 'no'
};
var currencyCodes = exports.currencyCodes = {
  CAD: 'CAD'
};

// TODO: remove when formType field is deprecated
var formTypes = exports.formTypes = {
  FORM: 'form',
  LEAD: 'lead'
};
// TODO ends

var loginStatusTypes = exports.loginStatusTypes = {
  LOGGED_IN: 'logged_in',
  NOT_LOGGED_IN: 'not_logged_in'
};
var loginTypes = exports.loginTypes = {
  API: 'api',
  BIOMETRIC: 'biometric',
  EMAIL: 'email',
  KEYCHAIN: 'keychain',
  MAGIC_LINK: 'magicLink',
  SSO: 'sso'
};
var qualledTypes = exports.qualledTypes = {
  GENERIC: 'generic',
  QUALLED: 'qualled'
};
var refinementTypes = exports.refinementTypes = {
  CHANGED: 'changed_phrase',
  ORIGINAL: 'original_search'
};
var visibilityTypes = exports.visibilityTypes = {
  HIDDEN: 'hidden',
  VISIBLE: 'visible'
};
var webInteractionTypes = exports.webInteractionTypes = {
  DOWNLOAD: 'download',
  OTHER: 'other'
};